import { FCX } from "@datassential/platform-ui-lib";
import { useConsumerGroupsContext } from "@pages/Profile/components/ConsumerGroups/ConsumerGroups";
import { useDeliveryServices } from "@core/CommonDataContext";
import {
    ConsumerGroupsTableItem,
    useConsumerGroupsTableMetrics
} from "./ConsumerGroupsTableConfig";
import { useMemo } from "react";
import Common from "@pages/Profile/components/ConsumerGroups/Common";

const Delivery: FCX = (props) => {
    const getMetricsData = useConsumerGroupsTableMetrics();
    const { data } = useConsumerGroupsContext();

    const options = useDeliveryServices();

    const itemsData = useMemo(
        (): ConsumerGroupsTableItem[] => {
            return (data.deliveryService ?? []).map((item) => {
                const itemData = options.find((i) => i.id === item.id);

                return {
                    id: item.id,
                    name: itemData?.name ?? '',
                    baseSize: item.base ?? 0,
                    metrics: getMetricsData(item.metrics ?? []),
                };
            });
        },
        [options, data.deliveryService, getMetricsData]
    );

    return (
        <Common {...props} data={itemsData}/>
    );
}

export default Delivery;